const routesWithoutTimeout = ["system@login", "system@cutover", "system@lock", "system@resetPassword"];

const isRouteWithTimeout = to => !routesWithoutTimeout.includes(to.name);

export default isRouteWithTimeout;
